export default __webpack_public_path__ + "static/media/luanchBtn.48f70849.png";